import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { gatePassApi } from 'api';
import { GATEPASS_STATUS } from 'constants/gatepass';
import BatchCodeVerifyModal from './BatchCodeVerifyModal';

const GatePassSubmitButton = ({
  gatePassId,
  currentStatus,
  onSuccess,
  disabled,
  items,
  isExpireDateRequired,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const submitGatePass = async () => {
    setIsLoading(true);
    try {
      await gatePassApi.submit(gatePassId);
      toast.success('GatePass submitted successfully!');
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      toast.error('Failed to submit GatePass.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = () => {
    if (isExpireDateRequired) {
      setShowVerifyModal(true);
    } else {
      submitGatePass();
    }
  };

  if (currentStatus !== GATEPASS_STATUS.CREATED) {
    return null;
  }

  return (
    <>
      <Button
        variant="success"
        size="sm"
        onClick={handleClick}
        disabled={isLoading || disabled}
      >
        {isLoading ? 'Submitting...' : 'Submit GatePass'}
      </Button>
      <BatchCodeVerifyModal
        show={showVerifyModal}
        onHide={() => setShowVerifyModal(false)}
        items={items || []}
        onVerified={submitGatePass}
      />
    </>
  );
};

GatePassSubmitButton.propTypes = {
  gatePassId: PropTypes.number.isRequired,
  currentStatus: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  disabled: PropTypes.bool,
  items: PropTypes.array,
  isExpireDateRequired: PropTypes.bool,
};

export default GatePassSubmitButton;
